import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const Password = observer(class Password extends React.Component {
  componentWillMount() {
    this.state = {
      valid: false
    }
  }

  checkPassword(e, callback) {
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;

    if(passwordPattern.test(e.target.value)) {
      e.target.setCustomValidity('');
    } else {
      e.target.setCustomValidity('invalid');
    }

    this.setState({
      valid: passwordPattern.test(e.target.value)
    })

    if(callback) {
      callback(e, 'password');  
    }
  }

  render() {
    const { translation } = this.props;

    return(
      <div className={`password-wrap ${this.state.valid ? 'valid' : 'invalid'}`}>
        <input
          type="password"
          id={this.props.id}
          onChange={(e) => {this.checkPassword(e, this.props.changeFunction)}}
          required
          aria-required="true"
          aria-describedby="password-tooltip"
        />

        <i className="password-validity">
          {this.state.valid &&
            <icons.iconCheckCircle />
          }

          {!this.state.valid &&
            <icons.iconNo />
          }

          <span className="meta">{this.state.valid ? 'Valid' : 'Invalid'}</span>
        </i>

        <div className="tooltip">
          <div id="password-tooltip" className="tooltip__body" role="tooltip">
            {translation.tooltip_body}

            <ul className="tooltip__list">
              {translation.requirements.map(
                (key, i) =>
                <li key={i}>{key}</li>
              )}
            </ul>
          </div>
        </div>
      </div>
    );
  }
})

export default translate('Password')(Password);


// WEBPACK FOOTER //
// ./src/app/components/Common/Password.js